<nav class="navbar sticky-top navbar-light bg-ligth">
  <div class="container-xl">
    <div class="row" style="width: 100vw !important">
      <!-- mobile -->
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <a style="text-decoration: none" href="https://portaldolojista.blukit.com.br/auth" target="_blank">
            <div class="d-flex align-items-center m-2">
              <div class="d-xl-none">
                <i class="bi bi-shop" style="font-size: 24px; color: var(--main-blue)"></i>
              </div>
              <div
                style="line-height: 1; text-align: start; font-size: 11px; color: var(--main-blue); cursor: pointer;"
                class="d-xl-none p-1">
                <span>PORTAL<br />DO LOJISTA</span>
              </div>
            </div>
          </a>
        </div>
        <div>
          <i (click)="openModalSearch()" class="d-xl-none bi bi-search fa-fw fa-2x fw-bold p-1"
            style="font-size: 26px; color: var(--main-blue); font-weight: 900; cursor: pointer;"></i>
          <i (click)="openModalMenu()" class="d-xl-none bi bi-list fa-fw fa-2x fw-bold p-1"
            style="font-size: 26px; color: var(--main-blue); font-weight: 900; cursor: pointer;"></i>
        </div>
      </div>
      <div class="d-xl-none container-area-mobile">
        <a href="" class="nav-brand">
          <img style="margin-bottom: -5em" src="/assets/logos/logo-yellow.svg" alt="" width="81px" height="57px" />
        </a>
      </div>
      <!-- fim mobile -->

      <div class="d-none d-xl-flex col-md-auto col-lg-1">
        <a href="" class="nav-brand">
          <img src="/assets/logos/logo-yellow.svg" alt="" width="95px" height="95px" />
        </a>
      </div>

      <div class="d-none col-xl-9 d-xl-flex align-items-end justify-content-end">
        <ul class="nav">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="">Home</a>
          </li>

          <li class="nav-item d-flex align-items-start dropdown" aria-haspopup="true" aria-expanded="false">
            <a class="nav-link" (mouseover)="hideCategory()" href="/linhas">Produtos</a>
            <a class="nav-link" (mouseover)="hideCategory()">
              <img src="/assets/icons/icon-arrow.svg" alt="" style="width: 10px; height: 7px;" />
            </a>

            <div class="dropdown-menu">
              <div class="d-flex">
                <div class="d-flex flex-column nav-link dropdown">
                  <div *ngFor="let category of categories" style="min-width: 200px; width: 100%;">
                    <a class="dropdown-item dropleft d-flex justify-content-between align-items-center"
                      routerLink="linhas/{{ category.slug }}" (mouseover)="showSubcategory(true, category)">
                      {{ category.nome }}
                      <span *ngIf="category && !category.ambiente"
                        style="color: #848fa3; font-size: 14px; text-align: end">
                        <i class="bi bi-chevron-right m-2 pt-2"></i>
                      </span>
                    </a>
                  </div>
                </div>

                <div *ngIf="subCategories && subCategories.length" style="border: 1px solid #ccc; margin: 0 15px"></div>
                <div *ngIf="subCategories && subCategories.length" class="d-flex flex-column dropdown-subitem"
                  style="min-width: 200px">
                  <a class="dropdown-item dropleft d-flex justify-content-between align-items-center"
                    *ngFor="let subCategorie of subCategories" (mouseover)="showSubSubcategory(true, subCategorie)"
                    href="{{subCategorie.link}}" (click)="hideCategory()">
                    {{ subCategorie.nome }}
                    <span style="color: #848fa3; font-size: 14px; text-align: end">
                      <i class="bi bi-chevron-right m-2 pt-2"></i>
                    </span>
                  </a>
                </div>

                <div *ngIf="subSubCategorie && subSubCategorie.length"
                  style="border: 1px solid #ccc; margin: 0 15px"></div>
                <div *ngIf="subSubCategorie && subSubCategorie.length" class="d-flex flex-column dropdown-subitem"
                  style="width: 200px">
                  <div *ngFor="let subCategorieItem of subSubCategorie">
                    <a *ngIf="subCategorieItem.hasProducts" href="{{subCategorieItem.link}}">
                      {{ subCategorieItem.nome }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item d-flex" (mouseover)="hideCategory()">
            <a class="nav-link dropdown" routerLink="/onde-encontrar">Onde encontrar</a>
          </li>

          <li class="nav-item d-flex dropdown" (mouseover)="hideCategory()">
            <a class="nav-link dropdown" href="/atendimento">Atendimento</a>
            <a class="nav-link" aria-haspopup="true" aria-expanded="false">
              <img style="width: 10px; height: 7px;" src="../../../../assets/icons/icon-arrow.svg" alt="" />
            </a>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="atendimento/assistencia-tecnica">Assistência Técnica</a>
              <a class="dropdown-item" href="atendimento/duvidas-frequentes">Dúvidas Frequentes</a>
              <a class="dropdown-item" href="atendimento/fale-conosco">Fale Conosco</a>
              <a class="dropdown-item" href="atendimento/financeiro">Financeiro</a>
              <a class="dropdown-item" href="atendimento/ouvidoria">Ouvidoria</a>
              <a class="dropdown-item"
                href="https://faleseguro.com.br/welcome?uuid=3941ff81-1ade-4673-ad17-0994d7bf5a41" target="_blank">Canal
                de Ética</a>
            </div>
          </li>

          <li class="nav-item d-flex dropdown" (mouseover)="hideCategory()">
            <a class="nav-link dropdown" href="sobre">Sobre a Blukit</a>
            <a class="nav-link" aria-haspopup="true" aria-expanded="false">
              <img style="width: 10px; height: 7px;" src="../../../../assets/icons/icon-arrow.svg" alt="" />
            </a>
            <div class="dropdown-menu">
              <div class="d-flex">
                <div class="d-flex flex-column nav-link dropdown">
                  <a class="dropdown-item" href="sobre/sobre-download" (mouseover)="showReports(false)">Download</a>
                  <a class="dropdown-item dropleft" (mouseover)="showReports(false)" href="sobre">Sobre a Blukit</a>
                  <a class="dropdown-item dropleft" (mouseover)="showReports(true)">
                    Relatório de Transparência
                    <span style="color: #848fa3; font-size: 12px; text-align: end">
                      <i class="bi bi-chevron-right"></i>
                    </span>
                  </a>
                </div>

                <div *ngIf="subcategorieReports.length" style="border: 1px solid #ccc; margin: 0 15px"></div>
                <div>
                  <div *ngIf="subcategorieReports && subcategorieReports.length"
                    class="d-flex flex-column dropdown-subitem" style="width: 200px">
                    <a class="dropdown-item dropleft d-flex justify-content-between align-items-center"
                      *ngFor="let subCategorie of subcategorieReports" href="{{subCategorie.link}}" target="_blank"
                      (click)="hideReport()">
                      {{ subCategorie.nome }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown" (mouseover)="hideCategory()" style="padding: 0 15px 0 0px;">
  <a class="nav-link dropdown" href="/blog">Blog</a>
</li>

<li class="nav-item dropdown" (mouseover)="hideCategory()" style="padding: 0;">
  <a class="nav-link dropdown" target="_blank" href="https://ead.blukit.com.br/">EAD</a>
</li>

<li class="nav-item dropdown" (mouseover)="hideCategory()" style="padding: 0; white-space: nowrap; margin-left: 10px;">
  <a class="nav-link dropdown" target="_blank" href="https://blukit.portaldetalentos.senior.com.br/">
    Trabalhe Conosco
  </a>
</li>
        </ul>
      </div>

      <div class="d-flex align-items-center justify-content-center col-md-auto col-lg-2 header-nav">
        <div class="m-2 d-none d-xl-flex" style="height: 40px; border: 1px solid #848fa35e !important"></div>

        <a style="text-decoration: none" href="https://portaldolojista.blukit.com.br/auth" target="_blank">
          <div class="d-flex align-items-center m-2" style="padding-right: 7px">
            <div class="d-none d-xl-flex p-2 pt-0 pb-0">
              <i class="bi bi-shop" style="font-size: 26px; color: var(--main-blue)"></i>
            </div>
            <div
              style="line-height: 1; text-align: start; font-size: 11px; color: var(--main-blue); cursor: pointer;"
              class="d-none d-xl-flex p-1">
              <span>PORTAL<br />DO LOJISTA</span>
            </div>
          </div>
        </a>

        <i class="d-none d-xl-flex bi bi-search fa-fw fa-2x fw-bold p-1"
          style="font-size: 22px; color: var(--main-blue); font-weight: 900; cursor: pointer;"
          (click)="openModalSearch()"></i>
      </div>
    </div>
  </div>
</nav>
